<!--
  <ExplorerHeader2
    title="My view title"
    :filters="QFilters"
    :view='ExporerTable'
    :calendar_props='{props}'
    :filter_list='["Filter1", "Filter2"]'
    :qunits="QUnitCollection"
    @update="my_filters_update_handler(QFilters)"
    @update_qunits="update_qunits()"
    @change_view="my_view_handler(view)"
    @calendar-action="my_action_handler(action, ...args)"
  />

    view is one of ["ExplorerTable", "ExplorerCalendar", "ExplorerReport"]
-->

<template>
  <div>
    <div class="explorer-header">
    <div 
      class="explorer-header-cont explorer-header-width-space"
      :class="[is_mobile ? 'mobile' : '',(props.header_props || {}).header_class]"
    >
    
      <!-- Add button -->
      <div class="explorer-header-title">
        <GenericAddButton
          v-if="!hide_add_button"
          :filters="filters"
          :small="is_mobile"
          :is_mobile="is_mobile"
          @update="update_qunits"
        />
        <!-- Title -->
        <div
          v-if="!(props.header_props || {}).hide_title"
          :class="'qmkey-view-title '+ (props.header_props || {}).title_class"
          >
          {{ title }}
        </div>
      </div>
      <div class="explorer-header-cont explorer-header-end ml-auto pa-0" :class="(props.header_props || {}).header_filter_class">
        <ExplorerCalendarHeader
          v-if="view == 'ExplorerCalendar'"
          :calendar_props="props.calendar_props"
          :filters="filters"
          @calendar-action="forward_calendar_actions"
          @update-qunits="update_qunits"
          
          @update_filters="update_filters"
          @update_props="update_props"
        />
      
        <slot
          name="extra-filters"
          :filters="filters"
          @update="update_filters"
        >
        </slot>
      
        <!-- Filters -->
        <Filters
          :filters="filters"
          @update="update_filters"
          :filter_list="filter_list"
          :is_mobile="is_mobile"
          :filter_props="props.filter_props"
        />
      </div>
        <div class="text-right explorer-header-tabs ml-auto" v-if="!(props.header_props || {}).hide_tabs">
        <!-- View tabs -->
        <ViewSelector
          v-if="!(props.header_props || {}).hide_view_selector"
          :is_mobile="is_mobile"
          :views="views"
          :view_name="view"
          @change_view="change_view"
        />
              
        <ReportList
          v-if="!is_mobile && !(props.header_props || {}).hide_report_list"
          :filters="filters"
          :is_mobile="is_mobile"
        ></ReportList>
      
        <CheckTemplate
          v-if="!is_mobile && !(props.header_props || {}).hide_templates"
          :filters="filters"
          :qunits="qunits"
          :is_mobile="is_mobile"
        ></CheckTemplate>
      </div>
      </div>
      
      <slot name="extra-header"></slot>
    </div>
    
    <ExplorerFilterChips 
      class="qmkey-header-filter-chips"
      v-if="is_mobile && !(props.header_props || {}).hide_filter_chips"
      :filters="filters"
      @update="update_filters"
    />
  </div>
</template>
  
  
<style lang="scss">
  @import '@/sass/explorer.scss';
  .explorer-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  
  .explorer-header-cont {
    display: flex;
    align-items: center;
    gap: 1em;
    /* height: 30px; */
    /*padding-left: 1em;
    padding-right: 1em;
    padding-top: .5em;
    padding-bottom: .5em;*/
  }
  .explorer-header-title {
    display: flex;
    align-items: center;
    gap: 1em;
    flex-grow: 1;
  }

  .explorer-header-width-space {
    flex-wrap: wrap;
    flex-grow: 1;
  }

  .explorer-header-end {
    justify-self: end;
  }
  
  explorer-header-tabs {
    display: flex;
    align-items: center;
  }
  .qmkey-header-filter-chips {
   margin-top: 0.5em;
   margin-bottom: 0.5em;
  }
</style>
  
  
<script>
  import QUnitCollection from '@/qunit/QUnitCollection';
  import GenericAddButton from '@/components/explorer/GenericAddButton';
  import ViewTitle from '@/components/ViewTitle';
  import ExplorerCalendarHeader from '@/components/explorer/ExplorerCalendarHeader';
  import Filters from '@/components/explorer/filters/Filters';
  import ReportList from '@/components/explorer/ReportList'
  import CheckTemplate from '@/components/CheckTemplate'
  import {mapState} from 'vuex'
  import ViewSelector from '@/components/explorer/ViewSelector'
  import ExplorerFilterChips from '@/components/explorer/ExplorerFilterChips';
  import { QFilters, get_qfilter } from '@/qunit/filters';
  
  
  export default {
    name: 'ExplorerHeader2',
  
    props: {
      hide_add_button: Boolean,
      title: String,
      filters: {
        type: QFilters,
        required: true,
        default: () => new QFilters()
      },
      disable_advanced_filter: Boolean,
      disable_views: Boolean,
      hide_charts_view: Boolean,
      props: {},
      views: {default: ()=> ([])},
      view: {default: 'ExplorerTable'},
      filter_list: {default: () => null},
      qunits: {type: QUnitCollection},
      disable: Boolean,
    },
  
    components: {
      Filters,
      ExplorerCalendarHeader,
      ViewTitle,
      GenericAddButton,
      ReportList,
      CheckTemplate,
      ViewSelector,
      ExplorerFilterChips,
    },
  
    data: () => ({
    }),
  
    computed: {
      ...mapState(['is_mobile',]),
    },
  
    methods: {
      update_filters(new_filters) {
        this.$emit('update', new_filters);
      },
  
      update_qunits(qunit) {
        let filters = this.filters.copy();
        filters.set_filter(get_qfilter('pk',qunit.uid),true)
        this.$emit('update', filters);
        this.$emit('update_qunits', qunit);
      },
  
      change_view(target) {
        this.$emit("change_view", target);
      },
  
      forward_calendar_actions(actions, ...args) {
        this.$emit("calendar-action", actions, ...args);
      },
      
      update_props(props) {
        this.$emit('update_props',props);
      },
    },
  }
  
</script>
